import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { MembershipHeader, MembershipTypes } from './components';
import { actionGetMembershipPackage } from 'actions';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';

const { Membershipheadernewmsg, Membershipheaderrenewmsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        // padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            // marginTop: theme.spacing(5)
        }
    }
}));

const Memberships = (props) => {

    const classes = useStyles();

    const constnextredirect = () => {
        props.history.push({
            pathname: '/checkout'
        })
    }

    let shopcartmember = false;
    let membershipPackage;
    let isRenewPackage = false;
    const dispatch = useDispatch();

    const GetMemberShip = () => {

        let membership;

        if (membershippackagesreducer.membershipPackage && membershippackagesreducer.membershipPackage.MembershipPackageID == props.match.params.id) {
            membership = membershippackagesreducer.membershipPackage;

            if (props.match.path == "/memberships/join/:id") {
                //original shopcartmember = false;
                shopcartmember = true;

            }
            else {
                shopcartmember = true;
            }
        }
        else if (membershipPackages && membershipPackages.length > 0 && membershipPackages.find(x => x.MembershipPackageID == parseInt(props.match.params.id)) !== undefined) {
            membership = membershipPackages.find(x => x.MembershipPackageID == props.match.params.id);
            shopcartmember = true;
        }
        else {
            membership = membershippackagesreducer.membershipPackage;
            shopcartmember = false;
        }

        if (props.match.path == "/memberships/renew/:id") {
            isRenewPackage = true;
        }

        return membership;
    }


    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const membershippackagesreducer = useSelector(state => state.reducerMembershipPackages);

    membershipPackage = GetMemberShip();

    useEffect(() => {
        if (props.match.path == "/memberships/join/:id") {
            actionGetMembershipPackage(dispatch, props.match.params.id);
        }
    }, []);

    const GetMembershipTypes = () => {
        let membershipTypesID = "";
        if (membershipPackage && membershipPackage.MembershipProducts && membershipPackage.MembershipProducts.length > 0) {
            membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(m => {

                if (membershipTypesID.length == 0) {
                    membershipTypesID += m.MembershipTypeID;
                }
                else {
                    membershipTypesID += "," + m.MembershipTypeID;
                }
            });
        }

        return membershipTypesID;
    }

    return (

        <div className={classes.root}>
            <MembershipHeader membershipPackage={membershipPackage} displayMsg={isRenewPackage ? Membershipheaderrenewmsg : Membershipheadernewmsg} isRenew={isRenewPackage} />
            <MembershipTypes
                membershipTypeIDs={GetMembershipTypes()}
                membershipPackage={membershipPackage}
                shopcartmember={shopcartmember}
                constnextredirect={constnextredirect}
                isRenewPackage={isRenewPackage}  {...props}
                membershipPackageID={parseInt(props.match.params.id)}
            />


        </div>
    );
};

export default Memberships;
